import { parseURI } from '@cian/http-api';
import { IFilters } from '../../types/filters';
import { IHistoryState } from '../../types/history';

interface IParams {
  filters?: IFilters;
  page?: number;
}

/**
 * Обновляет URL страницы через HistoryAPI
 */
export const updateUrl = ({ filters, page }: IParams) => {
  const url = parseURI(window.location.href);
  const query = new URLSearchParams(url.query);

  if (page && page !== 1) {
    query.set('page', String(page));
  } else {
    query.delete('page');
  }

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      const isEmptyArray = Array.isArray(value) && !value.length;
      const isEmptyValue = !value;

      if (isEmptyValue || isEmptyArray) {
        query.delete(key);
      } else {
        query.set(key, String(value));
      }
    });
  }

  const queryString = query.size ? `?${query}` : '';
  const newUrl = queryString ? url.path + queryString : url.path;
  const historyState: IHistoryState = { filters, page };

  // Чтобы избежать дублирования истории
  if (queryString !== window.location.search) {
    window.history.pushState(historyState, '', newUrl);
  }
};
